import ConfirmNumberForm from './ConfirmNumberForm';

export default ConfirmNumberForm;


// WEBPACK FOOTER //
// ./src/components/forms/ConfirmNumberForm/index.js